<template>
    <div>

        <!-- Breadcrumb Section Start -->
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <h2>{{ $t('Your Orders')}}</h2>
                            <nav>
                                <ol class="breadcrumb mb-0">
                                    <li class="breadcrumb-item active" aria-current="page">{{ $t('Your Orders')}}</li>
                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Breadcrumb Section End -->

        <!-- Cart Section Start -->
        <section class="cart-section section-b-space">
            <div class="container-fluid-lg">
                <div class="row g-sm-4 g-3">
                    <div class="col-xxl-9 col-lg-8">
                        <div class="cart-table order-table order-table-2">
                            <div class="table-responsive">
                                <table class="table mb-0">
                                    <tbody>

                                    <tr v-for="item in order.items">
                                        <td class="product-detail">
                                            <div class="product border-0">


                                                <router-link :to="{name: 'products.show', params: { id: item?.product?.id, lang : $i18n.locale  }}"
                                                             class="product-image" v-if="item?.product !== null">

                                                    <img :src="item?.product?.image ?? '/theme/assets/images/more/product-card.png'" class="img-fluid blur-up lazyload" :alt="item?.product?.name">
                                                </router-link>

                                                <div class="product-detail">
                                                    <ul class="product-detail text-start">
                                                        <li class="name">
                                                            <router-link :to="{name: 'products.show', params: { id: item?.product?.id , lang : $i18n.locale  }}">
                                                                {{ item?.product?.name }}
                                                            </router-link>
                                                        </li>
                                                        <li class="name" v-if="item?.selected_price !== null">
                                                                {{ item?.selected_price?.name }}
                                                        </li>

                                                        <li class="text-content" v-for="attribute in item?.attributeValues">

                                                            <span class="text-title"> {{ attribute?.name }} :</span>

                                                            {{ attribute?.value }}
                                                        </li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </td>

                                        <td class="price">
                                            <h4 class="table-title text-content">{{ $t('Price')}}</h4>
                                            <h6 class="theme-color">{{ item?.price_tax }} ر.س</h6>
                                        </td>

                                        <td class="quantity">
                                            <h4 class="table-title text-content">{{ $t('Qty')}}</h4>
                                            <h4 class="text-title">{{ item?.quantity }}</h4>
                                        </td>

                                        <td class="subtotal">
                                            <h4 class="table-title text-content">{{ $t('Total') }}</h4>
                                            <h5>{{ item?.total_price_tax }} ر.س</h5>
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="col-xxl-3 col-lg-4">
                        <div class="row g-4">
                            <div class="col-lg-12 col-sm-6">
                                <div class="summery-box">
                                    <div class="summery-header">
                                        <h3>{{ $t('Price Details')}}</h3>
                                        <h5 class="ms-auto theme-color">({{ order?.items?.length }} {{ $t('Items') }} )</h5>
                                    </div>

                                    <ul class="summery-contain">
                                        <li>
                                            <h4>{{ $t('Subtotal')}}</h4>
                                            <h4 class="price">{{ order.subtotal }} {{ $t('priceSymbol') }}</h4>
                                        </li>

                                        <li>
                                            <h4> {{ $t('Shipping and delivery') }} </h4>
                                            <h4 class="price">{{ order?.shipping_cost }} {{ $t('priceSymbol') }}</h4>
                                        </li>

                                        <li>
                                            <h4>{{ $t('Tax')}}</h4>
                                            <h4 class="price">{{ order?.tax_amount }} {{ $t('priceSymbol') }}</h4>
                                        </li>

                                    </ul>

                                    <ul class="summery-total">
                                        <li class="list-total">
                                            <h4>{{ $t('Total') }}</h4>
                                            <h4 class="price">{{ order.total_price }} {{ $t('priceSymbol') }}</h4>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-12" v-if="order?.note">
                                <div class="summery-box">
                                    <div class="summery-header d-block">
                                        <h3>{{ $t('Notes') }}</h3>
                                    </div>

                                    <p class="p-3">{{ order?.note }}</p>

                                </div>
                            </div>

                            <div class="col-12">
                                <div class="summery-box">
                                    <div class="summery-header d-block">
                                        <h3>{{ $t('Payment') }}</h3>
                                    </div>

                                    <h4 class="px-3 pt-3">{{ order?.payment_status_value }}</h4>

                                    <ul class="summery-contain pb-0 border-bottom-0">

                                        <li class="d-block" v-if="order.payment_status == 'paid'">
                                            <h4 class="mtb2 mb-2">{{ $t('Payment method') }}</h4>
                                            <h4>{{ order?.transaction?.card?.type }}</h4>
                                            <h4>{{ order?.transaction?.card?.last4 }}</h4>
                                            <h4>{{ order?.transaction?.card?.country }}</h4>
                                        </li>

                                        <li class="d-block pt-0">
                                            <p class="text-content">

                                                <a v-if="order?.can_pay === true"
                                                   class="btn btn-animation btn-sm mend-auto"
                                                   :href="'/payment?id=' + order?.id ">
                                                    {{ $t('Pay now') }} <i class="fa-solid fa-arrow-left icon"></i>
                                                </a>

                                            </p>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                            <div class="col-lg-12 col-sm-6">
                                <div class="summery-box">
                                    <div class="summery-header d-block">
                                        <h3>{{ $t('Shipping Address') }}</h3>
                                    </div>

                                    <ul class="summery-contain pb-0 border-bottom-0">



                                            <li class="d-block">
                                                <b>{{ order?.address_data?.name }}</b>
                                                <!--                                                <span>{{ order?.address?.city?.name }}</span>-->
                                            </li>

                                            <li class="d-block">
                                                <b>{{ order?.address_data?.description }}</b>
                                                <!--                                                <span>{{ order?.address?.postal_code }}</span>-->
                                            </li>

                                            <li class="d-block">
                                                <b>{{ order?.address_data?.phone }}</b>
                                                <!--                                                <span>{{ order?.address?.phone }}</span>-->
                                            </li>



                                        <!--                                        <li class="d-block">-->
<!--                                            <h4>{{ order?.address?.country?.name }}</h4>-->
<!--                                            <h4 class="mt-2">{{ order?.address?.city?.name }}</h4>-->
<!--                                        </li>-->

<!--                                        <li class="d-block">-->
<!--                                            <h4>{{ order?.address?.address }}</h4>-->
<!--                                            <h4 class="mt-2">{{ order?.address?.postal_code }}</h4>-->
<!--                                        </li>-->

<!--                                        <li class="d-block">-->
<!--                                            <h4>{{ order?.address?.name }}</h4>-->
<!--                                            <h4 class="mt-2">{{ order?.address?.phone }}</h4>-->
<!--                                        </li>-->


<!--                                        <li class="pb-0">-->
<!--                                            <h4>Expected Date Of Delivery:</h4>-->
<!--                                            <h4 class="price theme-color">-->
<!--                                                <a href="order-tracking.html" class="text-danger">Track Order</a>-->
<!--                                            </h4>-->
<!--                                        </li>-->
                                    </ul>

                                    <ul class="summery-total" v-if="order?.delivery !== null">
                                        <li class="list-total">
                                            <h4>{{ $t('Shipment status') }} : </h4>
                                            <h4 class="fw-bold">{{ order?.delivery?.status_value }}</h4>
                                        </li>
                                    </ul>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Cart Section End -->
    </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    data() {
        return {
            order: []
        }
    },
    created() {

        const id = toast.info(this.$t('Getting content ...'),{ icon: 'fa-solid fa-download' });

        axios.get(`orders/${this.$route.params.id}`, {}).then(response => {

            this.order = response.data.data;

            toast.dismiss(id);
        }, response => {
            toast.dismiss(id);
        });
    },
}
</script>
